var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"rules":_vm.allRules,"label":_vm.label,"type":_vm.type,"suffix":_vm.suffix,"prefix":_vm.prefix,"number":_vm.number,"disabled":_vm.disabled,"min":_vm.min,"readonly":_vm.readonly},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }